import {CurrencyPipe} from '@angular/common';
import {Component, EventEmitter, Inject, Input, LOCALE_ID, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {Dropdown, RiderCoverage, Sex, Version} from '@emma-labs/shared/typescript';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Product} from '../coverage-builder-section.component';

interface CoverageSelected {
  coverageAmount: FormControl<number | null | undefined>;
  duration: FormControl<number | null | undefined>;
}

@UntilDestroy()
@Component({
  template: '',
})
export abstract class BaseRiderCardComponent {
  @Input({required: true}) set ratesVersion(ratesVersion: Version) {
    this._ratesVersion = ratesVersion;
    this.setProducts();
  }

  @Input({required: true}) set selectedRiderCoverageAmount(coverageAmount: number | undefined) {
    this.form.controls.coverageAmount.setValue(coverageAmount, {emitEvent: false});
    this.setProducts();
  }

  @Input() set selectedLifeInsuranceCoverageAmount(coverageAmount: number | undefined) {
    this._selectedLifeInsuranceCoverageAmount = coverageAmount;
    this.setProducts();
  }

  @Input() set smoker(_smoker: boolean) {
    this._smoker = _smoker;
    this.setProducts();
  }

  @Input() set sex(_sex: Sex) {
    this._sex = _sex;
    this.setProducts();
  }

  @Input() set age(_age: number) {
    this._age = _age;
    this.setProducts();
  }

  @Input() set selectedRiderDuration(duration: number | undefined) {
    this.form.controls.duration.setValue(duration, {emitEvent: false});
    this.setProducts();
  }

  @Output() coverageSelected = new EventEmitter<RiderCoverage>();

  form!: FormGroup<CoverageSelected>;
  _ratesVersion!: Version;
  _selectedLifeInsuranceCoverageAmount: number | undefined;
  _age?: number;
  _smoker?: boolean;
  _sex?: Sex;
  isPriceLoading = false;
  products: Product[] = [];
  coverageAmountOptions: Dropdown<number | undefined>[] = [];
  selectedProduct: Product = {name: {fr: 'Aucun', en: 'None'}, value: '0'};
  currencyPipe: CurrencyPipe;

  constructor(
    protected readonly fb: FormBuilder,
    @Inject(LOCALE_ID) locale: string,
  ) {
    this.form = this.createForm();
    this.currencyPipe = new CurrencyPipe(locale);
  }

  private createForm(): FormGroup<CoverageSelected> {
    const form = this.fb.group<CoverageSelected>({
      coverageAmount: this.fb.control(null),
      duration: this.fb.control(null),
    });

    form.controls.coverageAmount.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
      this.isPriceLoading = true;
    });

    return form;
  }

  protected abstract onSelect($event: RiderCoverage): void;

  protected abstract setProducts(): void;
}
